import { Report } from "@/services/backend/htz/report/types/report";
import { isImmutable } from "@/services/backend/documents/lib/document-state";
import {
  Card,
  CardAction,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/shared/components/ui/card";
import t from "@/lang/lang";
import { ReportPhotoAddButton } from "@/services/backend/htz/report/components/report-photo-add-button";
import { ReportPhotoCard } from "@/services/backend/htz/report/components/report-photo-card";

export function PhotosComponent({ report }: { report: Report }) {
  return (
    <Card>
      <CardHeader>
        <CardTitle>{t("Fotos")}</CardTitle>
        <CardDescription>
          {t(
            "Die Fotos der Komponenten der Anlage. Sie erscheinen im Anlagenbericht.",
          )}
        </CardDescription>
        <CardAction>
          <ReportPhotoAddButton
            report={report}
            disabled={isImmutable(report)}
          />
        </CardAction>
      </CardHeader>
      <CardContent>
        {report.photos.length === 0 ? (
          <p className="text-muted-foreground text-sm">
            {report.ahuId
              ? t("Noch keine Fotos erfasst.")
              : t("Dem Anlagenbericht ist noch keine RLT-Anlage zugewiesen.")}
          </p>
        ) : (
          <div className="grid gap-4 sm:grid-cols-2 xl:grid-cols-3">
            {report.photos.map((photo) => (
              <ReportPhotoCard
                key={photo.id}
                reportId={report.id}
                photoId={photo.id}
              />
            ))}
          </div>
        )}
      </CardContent>
    </Card>
  );
}
